/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('RestoreRenameNodeController', ['$scope', '$modalInstance', 'restoreNode', 'conflictNode', 'operationComplete', 'SyncAndShareNode',
        function($scope, $modalInstance, restoreNode, conflictNode, operationComplete, SyncAndShareNode) {
            $scope.modal =  $modalInstance.options;
            $scope.restoreNode = restoreNode;
            $scope.conflictNode = conflictNode;

            $scope.ok = function () {
                $scope.modal.loading = true;
                SyncAndShareNode.restore($scope.restoreNode,
                    function success() {
                        operationComplete($scope.restoreNode.is_directory ? "Folder restored." : "File restored.");
                        $modalInstance.close('reload_nodes');
                    }, function error(){
                        $modalInstance.close('reload_nodes');
                    });
            };

            $scope.cancel = $scope.close = function () {
                $modalInstance.dismiss('cancel');
            };
        }]);
